import { TableCell, TableRow } from "@mui/material";
import type { VirtualItem } from "@tanstack/react-virtual";
import React from "react";

export type VirtualizedRowProps = {
  virtualItems: VirtualItem[];
  totalSize: number;
  overVisibleRows: boolean;
  colSpan: number;
};

export const VirtualizedRow: React.FC<VirtualizedRowProps> = React.memo(
  ({ virtualItems, totalSize, overVisibleRows, colSpan }) => {
    if (virtualItems.length === 0) return null;

    const height = overVisibleRows
      ? virtualItems[0]!.start
      : totalSize - virtualItems[virtualItems.length - 1]!.end;

    if (height <= 0) return null;

    return (
      <TableRow aria-hidden sx={{ height }} tabIndex={-1}>
        <TableCell colSpan={colSpan} sx={{ height, p: 0, border: "none" }} />
      </TableRow>
    );
  },
);

VirtualizedRow.displayName = "VirtualizedRow";
